/**
 * ./src/auth/ProtectedRoute.js
 * 
 * This module is to protect specific routes.
 * It ensures that only authenticated and email-verified users can access the dashboard
 * or other restricted pages.
 * 
 */


import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
//import { auth } from '../firebase/firebase';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    console.log('No token found, redirecting to auth');
    return <Navigate to="/auth" />;
  }

  // const [loading, setLoading] = useState(true);
  // const [user, setUser] = useState(null);

  // useEffect(() => {
  //   const unsubscribe = auth.onAuthStateChanged((user) => {
  //     setUser(user);
  //     setLoading(false);
  //   });

  //   return () => unsubscribe();
  // }, []);

  // if (loading) {
  //   return <div>Loading...</div>; // You can replace this with a loading spinner
  // }

  // if (!user) {
  //   return <Navigate to="/auth" />;
  // }

  // if (!user.emailVerified) {
  //   alert('Please verify your email before accessing this page.');
  //   return <Navigate to="/auth" />;
  // }

  return children;
};

export default ProtectedRoute;
